'use client';

import { useEffect, useState } from 'react';
import { DaemonTriggerDetailContent, type DaemonTriggerDetailProps } from './DaemonTriggerDetailContent';
import { ResizableDetailPanel } from './ResizableDetailPanel';

export default function DaemonTriggerDetailPanel(props: DaemonTriggerDetailProps) {
  const { isOpen, trigger, onClose } = props;
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    if (!isOpen || !trigger) return;

    const cls = 'overflow-hidden';
    document.documentElement.classList.add(cls);
    document.body.classList.add(cls);

    return () => {
      document.documentElement.classList.remove(cls);
      document.body.classList.remove(cls);
    };
  }, [isOpen, trigger]);

  return (
    <ResizableDetailPanel isOpen={isOpen} onClose={onClose} canClose={!isBusy}>
      <DaemonTriggerDetailContent {...props} onBusyChange={setIsBusy} />
    </ResizableDetailPanel>
  );
}
